import fetchJSONHandleError from 'utils/NET/fetchJSONHandleError'
import { CDN_PIVOT } from 'core/constants/endpoints'
import store from 'utils/store/withMiddleware'
import { propAccessor } from '@hc-frontend/utils'

function getAllDetails() {
  let standardUrl = 'resources/dental-and-vision/v4/brilliant-standard-states.json'
  let restrictionUrl = 'resources/dental-and-vision/v4/brilliant-restriction-states.json'
  let visionUrl = 'resources/dental-and-vision/v4/vision.json'

  const state = propAccessor(store.getState().hcStorage, 'location.state_acronym')
  if (state === 'IL') {
    standardUrl = 'resources/dental-and-vision/v4/brilliant-standard-states-IL.json'
    restrictionUrl = 'resources/dental-and-vision/v4/brilliant-restriction-states-IL.json'
    visionUrl = 'resources/dental-and-vision/v4/vision-IL.json'
  }

  return Promise.all([
    fetchJSONHandleError({
      url: `${CDN_PIVOT}/${standardUrl}`
    }),
    fetchJSONHandleError({
      url: `${CDN_PIVOT}/${restrictionUrl}`
    }),
    fetchJSONHandleError({
      url: `${CDN_PIVOT}/${visionUrl}`
    })
  ])
}

export default getAllDetails
